// moz667: por culpa de vrdemo
var $ = jQuery;

var is_on_execution = false;
// deshabilitamos las notificaciones cuando estemos en un streaming
var disabled_notifications = $("body").hasClass("nonotif");
// Para solo reproducirlo una vez
var current_play_sound = false;

function next_notification_loop() {
    is_on_execution = false;

    if (disabled_notifications) {
        return;
    }
    setTimeout(notification_loop, 60000);
}

function show_notification(n) {
    // console.log(n.notification_type + ":" + n.id);

    // Si ya hemos mostrado la notificacion, no la volvemos a mostrar:
    if ($('.toast[data-notification-id="' + n.id + '"]').length > 0) return;

    var $toast = $('<div class="toast" role="alert" aria-live="assertive" aria-atomic="true" data-autohide="false" data-notification-id="' + n.id + '" />');

    if (n.related_data && n.related_data.is_rejected) {
        $toast.addClass("notification-rejected");
    }

    var $header = $('<div class="toast-header" />');
    $header.append($('<img src="' + N2M.NOTIFICATION_DEFAULT_IMG + '" height="12" />').attr("alt", N2M.EVENT_TITLE));

    if (n.title) {
        $header.append($('<strong class="mr-auto"></strong>').text(n.title));
    }

    var moment_date = n.sent_date ?
        moment(n.sent_date, "YYYY-MM-DD hh:mm:ss") :
        moment();
    
    moment.locale($("html").attr("lang"));

    var momment_from_now_msg = moment_date.fromNow();

    $header.append($('<small class="text-muted"></small>').text(n.sent_date_humanize));
    $header.append('<button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close"><span aria-hidden="true">&times;</span></button>');
    $toast.append($header);

    var main_img_src = "";
    var main_img_alt_text = "";

    if (n.notification_type == 'one2one' && n.related_data.avatar) {
        main_img_src = n.related_data.avatar;
        main_img_alt_text = n.related_data.full_name;
    } else {
        main_img_src = N2M.NOTIFICATION_DEFAULT_IMG;
        main_img_alt_text = N2M.EVENT_TITLE;
    }

    var $body_row = $('<div class="row" />').append(
        $('<div class="col-3" />').append(
            $('<img class="avatar-col rounded-circle img_login" />').attr("src", main_img_src).attr("alt", main_img_alt_text)
        )
    ).append(
        $('<div class="col-9" />').html(n.body)
    );

    $toast.append($('<div class="toast-body"></div>').append($body_row));
    $toast.append($('<div class="toast-footer"></div>').text(momment_from_now_msg));

    $('#notifications-list-wrap').hide();
    $("#notification-msg-container").append($toast);

    $toast.find(".toast-body a").on("click", function (e) {
        filter_notification_link_click(e, $toast, $(this));
    });

    $toast.on('hidden.bs.toast', function () {
        on_hiden_notification_event([$toast.data("notification-id")]);
    });

    $toast.toast('show');
}

function read_notifications(notification_ids, callback_allways) {
    $.ajax({
        method: "GET",
        url: N2M.NOTIFICATION_READ_URL,
        data: {
            id: JSON.stringify(notification_ids)
        }
    }).fail(function() {
        console.log("Error al intentar marcar como leidas las notificaciones pendientes.");
    }).always(function() {
        if (callback_allways) callback_allways();
    });
}

function get_pending_notifications(pending_notification_url, callback_done, callback_fail) {
    $.ajax({
        method: "GET",
        url: N2M.NOTIFICATION_NEW_URL
    }).done(function(data) {
        // console.log(data);
        callback_done(data);
    }).fail(function() {
        callback_fail();
    });
}

function notification_loop() {
    if (!is_on_execution) {
        is_on_execution = true;
    } else {
        return;
    }
    // console.log("Recuperando notificaciones pendiente")
    get_pending_notifications(N2M.NOTIFICATION_NEW_URL, function (pending_data) {
        if (!pending_data || !pending_data.notifications) {
            alertDialog.show({
                title: n2m_i18n("Sesión caducada"),
                message: n2m_i18n("Se ha terminado la sesión actual. Vuelve a loguearte para seguir aqui."),
                onHide: function () {
                    document.location = N2M.HOME_URL;
                }
            });
            return;
        }

        var n_auto_cta_ids = [];
        var other_notifications = [];
        var n_auto_cta = null;

        // TODO: Diferenciar entre notificaiones pendientes recientes
        // (de hace menos de 1 min 1 sec?) y notifiaciones pendientes antiguas
        // si son recientes sacar el mensaje... si son antiguas sacar el toast?
        // 1) Miramos si hay notificaciones pendientes de accion automatica
        for (var i in pending_data.notifications) {
            var n = pending_data.notifications[i];
            if (n.body == "") {
                n_auto_cta_ids.push(n.id);

                if (n_auto_cta == null) {
                    n_auto_cta = n;
                }
            } else {
                other_notifications.push(n);
            }
        }
        // 1.1) Si hay
        if (n_auto_cta_ids.length > 0) {
            // 1.1.1) marcamos como leidas las automaticas
            read_notifications(n_auto_cta_ids, function () {
                if (!disabled_notifications) {
                    // 1.1.2) cogemos la primera, y le redirigimos a la direccion
                    document.location = n_auto_cta.cta_url;
                    // 1.1.3) NO VOLVEMOS A EJECUTAR el loop
                }
            });
        // 1.2) Si no hay notificaciones de cta automatico y
        // si que hay de las otras
        } else if (other_notifications.length > 0) {
            // Solo reproducimos el sonido si hay nuevas
            var play_sound = false;

            // 1.2.1) Actualizamos el contador de notificaciones nuevas e iteramos el loop
            update_pending_count(other_notifications.length);

            // 1.2.2) Mostramos solo las nuevas notificaciones pendientes que ocurrieron
            // hace menos de 65 segundos (como comprobamos cada 60 segundos dejamos un gap)
            for (var i = 0; i < other_notifications.length; i++ ) {
                var n = other_notifications[i];
                if (n.seconds_ago < 65) {
                    if (!disabled_notifications) {
                        play_sound = true;
                        show_notification(n);
                    }
                }
            }

            // 1.2.3) Iteramos el loop
            next_notification_loop();

            // Como extra reproducimos un sonido si hay nuevas, lo hacemos al
            // final porque la reproduccion automatica de audios da por saco...
            if (play_sound && !current_play_sound) {
                current_play_sound = true;
                $.playSound(N2M.NOTIFICATION_AUDIO);
            }
        // 1.3) Si no hay iteramos el loop
        } else {
            next_notification_loop();
        }

        update_pending_count(other_notifications.length);

    }, function () {
        // console.log("Error al intentar recuperar las notificaciones cta-auto pendientes.");
        next_notification_loop();
    });
}

function filter_notification_link_click(e, $notification, $link) {
    e.preventDefault();

    read_notifications([$notification.data("notification-id")], function () {
        var new_url = $link.attr("href");
        var url_parts = new_url.split("#");

        document.location = $link.attr("href");

        if (url_parts[0] == document.location.pathname) {
            // si estas en la misma pagina (aunque sea con distinto hash) hacemos reload
            // para evitar comportamientos raros como tabs y otros #
            document.location.reload();
        }
    });
}

function on_hiden_notification_event(notification_ids) {
    if (notification_ids.length > 0) {
        read_notifications(notification_ids, function () {
            // Actualizamos la burbuja de leidas...
            var before_update = get_current_pending_count();
            // console.log(before_update);
            if (before_update > 1) {
                update_pending_count(before_update - notification_ids.length);
            } else {
                update_pending_count(0);
            }
        });
    }
}

function get_current_pending_count() {
    var $pending_count = $(".pending-notifications-count");
    return $pending_count.html() ? parseInt($pending_count.html(), 10) : 0;
}

var is_updating_pending_count = false;

function update_pending_count(new_value) {
    if (is_updating_pending_count) {
        setTimeout(function () {
            update_pending_count(new_value);
        }, 300);
        return;
    }

    is_updating_pending_count = true;
    var $pending_count = $(".pending-notifications-count");
    $pending_count.html(new_value);
    if (new_value == 0) {
        $pending_count.hide();
    } else {
        $pending_count.show();
    }
    is_updating_pending_count = false;
}

notification_loop();

$("a.notification-link").on("click", function (e) {
    e.preventDefault();
    $(".toast").hide();

    if($('#notifications-list-wrap').is(':visible')) {
        $( "#notifications-list-wrap" ).hide();
    } else {
        $( "#notification-list-content" ).html("").load( N2M.NOTIFICATION_INDEX_URL + " #notifications-table", function () {
            var count_items = 0;

            $("#notification-list-content .notification-row").each(function () {
                var $notification = $(this);
                $notification.find(".notification-body a").on("click", function (e) {
                    filter_notification_link_click(e, $notification, $(this));
                });
                count_items++;
            });
            if (count_items == 0) {
                $("#notification-list-content").addClass("no-notification-items");
            } else {
                $("#notification-list-content").removeClass("no-notification-items");
            }
        });
        $( "#notifications-list-wrap" ).show();
    }
});

$("#notifications-list-close a").on("click", function (e) {
    e.preventDefault();
    var notification_ids = [];

    $("#notification-list-content .notification-row").each(function () {
        var $n = $(this);
        if (!$n.data("is-read")) {
            notification_ids.push($n.data("notification-id"));
        }
    });

    on_hiden_notification_event(notification_ids);

    $( "#notifications-list-wrap" ).hide();
});
